"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OwnerDetailsForm = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _OwnerDetailsPropTypes = require("./OwnerDetailsPropTypes");
var _DefaultOwnerDetailsDisplaySettings = require("./DefaultOwnerDetailsDisplaySettings");
var _components = require("../../components");
var _helpers = require("../../helpers");
var _ownerDetailsFormDisplaySettingsPropTypes = require("../../propTypes/ownerDetailsFormDisplaySettingsPropTypes");
require("./ownerDetailsForm.scss");
var _objectHelpers = require("../../helpers/objectHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable react/forbid-prop-types */
const OwnerDetailsForm = _ref => {
  let {
    formContext,
    ownerDetailsDisplaySettings,
    routeDispatcher,
    formId = "ownerDetailsForm_".concat((0, _uuid.v4)().split('-')[0]),
    ownerDetails,
    globalDispatcher,
    readonlyMode = false
  } = _ref;
  const owner = (0, _react.useMemo)(() => ownerDetails || _OwnerDetailsPropTypes.emptyOwnerQuoteDetails, [ownerDetails]);
  const [showMembershipInputField, setShowMembershipInputField] = (0, _react.useState)(owner.hasMemberNumber);
  const missingDispatcher = () => {
    /* eslint-disable-next-line no-console */
    console.log('No dispatcher provided to OwnerDetailsForm to handle updates.');
  };
  const dispatcher = globalDispatcher || routeDispatcher || missingDispatcher;
  const {
    heading,
    headingReadonly,
    accordionBehaviour,
    showMembershipField,
    showPromoCodeField,
    showName,
    showBirthdate,
    showPostCode,
    ownerBirthdateInput,
    ownerEmailInput,
    ownerNameInput,
    ownerPostCodeInput,
    ownerMembershipRadios,
    ownerMemberNumberInput,
    ownerPromoCodeInput
  } = (0, _objectHelpers.OverrideMergeObjects)({
    baseObject: _DefaultOwnerDetailsDisplaySettings.DefaultOwnerDetailsDisplaySettings,
    overrideObject: ownerDetailsDisplaySettings || {}
  });
  const handleNameChange = event => {
    const name = event.target.value.split(' ').map(namePiece => (0, _helpers.Capitalize)(namePiece)).join(' ');
    dispatcher({
      type: 'setOwnerName',
      name
    });
    event.target.value = name;
  };
  const handleEmailChange = event => {
    dispatcher({
      type: 'setOwnerEmail',
      email: event.target.value
    });
  };
  const handleBirthdateChange = event => {
    dispatcher({
      type: 'setOwnerBirthdate',
      birthdate: event.target.value
    });
  };
  const handleMembershipStatusChange = value => {
    setShowMembershipInputField(value === 'yes');
  };
  const handleMembershipChange = value => {
    dispatcher({
      type: 'setOwnerMembership',
      memberNumber: value
    });
  };
  const handlePostCodeChange = event => {
    dispatcher({
      type: 'setOwnerPostCode',
      postcode: event.target.value
    });
  };
  const handlePromoCodeChange = event => {
    dispatcher({
      type: 'setOwnerPromoCode',
      promoCode: event.target.value
    });
  };
  return /*#__PURE__*/_react.default.createElement(_components.SectionWrapper, {
    isFixed: !accordionBehaviour,
    customCssClass: "ownerDetailsForm",
    heading: readonlyMode ? headingReadonly : heading,
    isOpen: true
  }, /*#__PURE__*/_react.default.createElement("fieldset", null, showBirthdate && /*#__PURE__*/_react.default.createElement(_components.OwnerBirthdate, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerBirthdate"),
    defaultValue: owner.birthdate ? (0, _helpers.DateToShortIsoString)(new Date("".concat(owner.birthdate))) : null,
    customChangeHandler: event => handleBirthdateChange(event)
  }, ownerBirthdateInput)), showBirthdate && /*#__PURE__*/_react.default.createElement(_components.OwnerBirthdateDatepicker, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerBirthdateDatepicker"),
    defaultValue: owner.birthdate ? (0, _helpers.DateToShortIsoString)(new Date("".concat(owner.birthdate))) : ''
  }, ownerBirthdateInput)), /*#__PURE__*/_react.default.createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerEmail"),
    autoComplete: "off",
    inputType: "email",
    defaultValue: owner.email,
    customChangeHandler: event => handleEmailChange(event)
  }, ownerEmailInput)), showName && /*#__PURE__*/_react.default.createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerName"),
    autoComplete: "off",
    defaultValue: (0, _helpers.FormatOwnerName)(owner),
    customChangeHandler: event => handleNameChange(event)
  }, ownerNameInput)), showPostCode && /*#__PURE__*/_react.default.createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerPostCode"),
    autoComplete: "off",
    defaultValue: owner.postcode,
    readOnly: readonlyMode,
    customChangeHandler: event => handlePostCodeChange(event)
  }, ownerPostCodeInput, {
    validation: readonlyMode ? null : ownerPostCodeInput.validation
  }))), showMembershipField && /*#__PURE__*/_react.default.createElement(_components.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "".concat(formId, "_ownerMembershipRadios"),
    name: "".concat(formId, "_ownerMembership"),
    required: true,
    value: owner.hasMemberNumber,
    onChange: event => handleMembershipStatusChange(event)
  }, ownerMembershipRadios)), showMembershipInputField && /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerMemberNumber"),
    autoComplete: "off",
    defaultValue: owner.memberNumber,
    customChangeHandler: event => handleMembershipChange(event)
  }, ownerMemberNumberInput))), showPromoCodeField && /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_ownerPromoCode"),
    autoComplete: "off",
    defaultValue: owner.promoCode,
    customChangeHandler: event => handlePromoCodeChange(event)
  }, ownerPromoCodeInput))));
};
exports.OwnerDetailsForm = OwnerDetailsForm;
OwnerDetailsForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any,
  ownerDetailsDisplaySettings: _propTypes.default.shape(_ownerDetailsFormDisplaySettingsPropTypes.OwnerDetailsFormDisplaySettingsPropTypes),
  formId: _propTypes.default.string.isRequired,
  ownerDetails: _propTypes.default.shape(_OwnerDetailsPropTypes.OwnerDetailsPropType),
  globalDispatcher: _propTypes.default.func,
  readonlyMode: _propTypes.default.bool,
  routeDispatcher: _propTypes.default.func
};
var _default = exports.default = {
  OwnerDetailsForm
};